module.exports = __webpack_public_path__ + "static/img/会计引擎2.42875e7b.png";